import React, { useState } from 'react';
import classNames from 'classnames';

import SimpleModal from 'components/base/SimpleModal';

import css from './style.scss';

/**
 * "General Information" nested modal (Figma 383-27031).
 *
 * Opened from the pencil beside the name (or "Add Now" on a new contact).
 * Edits a local copy and hands it back on Save, so Cancel discards cleanly.
 */

const Field = ({ name, label, value, placeholder, maxLength, onChange, className }) => (
  <div className={classNames(css.field, className)}>
    <div className={css.fieldLabel}>{label}</div>
    <input
      className={css.fieldInput}
      name={name}
      type="text"
      value={value || ''}
      placeholder={placeholder}
      maxLength={maxLength}
      onChange={onChange}
    />
  </div>
);

const GeneralInformationModal = ({ contact, onCancel, onSave }) => {
  const [draft, setDraft] = useState({
    firstName: contact.firstName || '',
    middleName: contact.middleName || '',
    lastName: contact.lastName || '',
    companyName: contact.companyName || '',
    suffix: contact.suffix || '',
  });

  const handleChange = (ev) => {
    const { name, value } = ev.target;
    setDraft((prev) => ({ ...prev, [name]: value }));
  };

  const fieldProps = { onChange: handleChange };

  return (
    <SimpleModal
      isOpen
      ignoreEscAndClickOutside
      uniqueId="contactGeneralInformation"
      wrapperClassName={css.nestedWrapper}
      modalClassName={css.nestedModal}
      modalHeaderWrapperClassName={css.headerWrap}
      modalBodyClassName={css.bodyWrap}
      modalFooterWrapperClassName={css.nestedFooter}
      customHeader={<div className={css.nestedCaption}>General Information</div>}
      customFooter={
        <>
          <button type="button" className={css.btnGhost} onClick={onCancel}>
            Cancel
          </button>
          <button
            type="button"
            className={classNames(css.btnPrimary, css.btnSave)}
            onClick={() => onSave(draft)}
          >
            Save
          </button>
        </>
      }
      modalBody={
        <div className={classNames(css.nestedBody, css.generalBody)}>
          <div className={css.fieldRow}>
            <Field
              name="firstName"
              label="First Name"
              placeholder="First Name"
              maxLength={100}
              value={draft.firstName}
              className={css.fieldName}
              {...fieldProps}
            />
            <Field
              name="middleName"
              label="Middle Name"
              placeholder="Middle Name"
              maxLength={100}
              value={draft.middleName}
              className={css.fieldName}
              {...fieldProps}
            />
            <Field
              name="lastName"
              label="Last Name"
              placeholder="Last Name"
              maxLength={100}
              value={draft.lastName}
              className={css.fieldName}
              {...fieldProps}
            />
          </div>

          <div className={css.fieldRow}>
            <Field
              name="companyName"
              label="Company Name"
              placeholder="Company Name"
              maxLength={200}
              value={draft.companyName}
              className={css.fieldCompany}
              {...fieldProps}
            />
            <Field
              name="suffix"
              label="Suffix"
              placeholder="Suffix"
              maxLength={50}
              value={draft.suffix}
              className={css.fieldSuffix}
              {...fieldProps}
            />
          </div>
        </div>
      }
    />
  );
};

export default GeneralInformationModal;
